export function trimIfNameField(field: string, value: unknown): unknown {
  return (field === "firstName" || field === "lastName") && typeof value === "string"
    ? value.trim()
    : value;
}

export function trimNameFields(data: Record<string, unknown>): Record<string, unknown> {
  return {
    ...data,
    firstName: typeof data.firstName === "string" ? data.firstName.trim() : data.firstName,
    lastName: typeof data.lastName === "string" ? data.lastName.trim() : data.lastName,
  };
}
